module.exports = __webpack_public_path__ + "static/media/fuwujixiao.77f995a7.jpg";